module.exports = __webpack_public_path__ + "media/images/contacts-7c0a8b9469aa4a524d31f5c65d82758a.svg";